import { useIsDesktop } from '~/@mid_ui/layout/useIsDesktop'
import { cn } from '~/shadcn/lib/utils'
import { ImmunityIndicator } from './_fee-immunity_ui/ImmunityIndicator'
import { SummaryBlock } from './_fee-immunity_ui/SummaryBlock'
import { FeeImmunityButtons } from './_fee-immunity_ui/FeeImmunityButtons'
import { useFeeImmunity } from './useFeeImmunity'
import { HeadingThree } from '~/@mid_ui/typography/HeadingThree'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { HeadingOne } from '~/@mid_ui/typography/HeadingOne'

const COLORS = {
  black: '#121212',
  white: '#FFFFFF',
  red: '#F00028',
  green: '#3BB200',
}

export function FeeImmunityPage() {
  const { hasFeeImmunity } = useFeeImmunity()
  const isDesktop = useIsDesktop()
  const isMobile = !isDesktop

  return (
    <div className="flex w-full flex-col">
      <PageContainer
        className={cn(
          'flex gap-4',
          isMobile
            ? 'flex-col items-start pt-12 pb-4'
            : 'flex-row items-center justify-between pt-20 pb-8'
        )}>
        <HeadingOne className={cn('font-semibold')}>
          Poplatková imunita
        </HeadingOne>
        <ImmunityIndicator hasUserFeeImmunity={hasFeeImmunity} />
      </PageContainer>

      <div
        className={cn('flex border-b flex-col md:flex-row')}
        style={{ borderColor: COLORS.black }}>
        <div
          className={cn(
            'flex flex-col justify-between after:content-[""] w-full md:w-2/5'
          )}
          style={{ borderColor: COLORS.black }}>
          <HeadingThree
            className={cn(
              'text-3xl px-8 pb-4 pt-8',
              'border-t border-b hidden md:block'
            )}
            style={{ borderColor: COLORS.black }}>
            Zhrnutie
          </HeadingThree>
          <PageContainer
            className={cn(
              'flex gap-x-4 gap-y-0 items-start flex-row flex-wrap justify-start md:flex-col border-t md:border-t-0'
            )}>
            <SummaryBlock label="STAV:" isMobile={isMobile}>
              <span
                style={{
                  color: isMobile
                    ? COLORS.black
                    : hasFeeImmunity
                      ? COLORS.green
                      : COLORS.red,
                }}>
                {hasFeeImmunity ? 'Aktívna' : 'Neaktívna'}
              </span>
            </SummaryBlock>
            <SummaryBlock label="K DISPOZÍCIÍ OD:" isMobile={isMobile}>
              {isMobile ? '6. 2026' : '30. júna 2026'}
            </SummaryBlock>
            <SummaryBlock label="PLATNÉ DO:" isMobile={isMobile}>
              {isMobile ? '12. 2026' : '31. decembra 2026'}
            </SummaryBlock>
          </PageContainer>
        </div>

        <div className={cn('w-full md:w-3/5 md:border-l')}>
          <HeadingThree
            className={cn('text-3xl px-8 pb-4 pt-8 border-t')}
            style={{ borderColor: COLORS.black }}>
            Informácie
          </HeadingThree>
          <PageContainer className="flex flex-col gap-[2.6rem] p-5 md:p-10 border-t">
            <p className="m-0 font-normal">
              Špeciálna ponuka: Ak investujete minimálne 1 000 € do 30. júna
              2026, získate poplatkovú imunitu až do konca roka 2026. Imunita
              platí na všetky vaše investície uskutočnené do 31. decembra 2026,
              teda aj tie pod 1 000 €.
            </p>
            <p className="m-0 font-normal">
              Počas tohto obdobia neplatíte žiadne poplatky z výnosov. Celý
              výnos zostáva vám.
            </p>
          </PageContainer>
        </div>
      </div>
      <PageContainer>
        <FeeImmunityButtons
          hasUserFeeImmunity={hasFeeImmunity}
          isMobile={isMobile}
        />
      </PageContainer>
    </div>
  )
}
